import React from "react";
import { Dialog } from "@actinc/dls/components";
import { Plus as PlusIcon } from "@actinc/dls/icons";
import {
  DialogContent,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { sortByName } from "../../services/utils";

const InsertMediaDialog = ({
  editor,
  mediaAssets = [],
  onClose,
  open = false,
}) => {
  const insertMedia =
    ({ src }) =>
    (e) => {
      onClose();
      const mediaType = src.slice(-3);
      const model = editor.model;
      const selection = model.document.selection;
      model.change((writer) => {
        switch (mediaType) {
          case "mp3":
          case "m4a":
            writer.insertElement("audio", { src: `${src}` }, selection.focus);
            break;
          case "mp4":
          case "m4v":
          case "ogg":
            writer.insertElement("video", { src: `${src}` }, selection.focus);
            break;
          default:
            console.error("unknown media type");
            break;
        }
      });
    };

  return (
    <Dialog maxWidth="md" onClose={onClose} open={open} title="Insert Media">
      <DialogContent dividers={true}>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left" key="File Name">
                  File Name
                </TableCell>
                <TableCell align="left" key="Description">
                  Description
                </TableCell>
                <TableCell align="right" key="Actions">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {mediaAssets.sort(sortByName).map((media) => (
                <TableRow key={media.name}>
                  <TableCell align="left">{media.name}</TableCell>
                  <TableCell align="left">{media.description}</TableCell>
                  <TableCell align="right">
                    <IconButton
                      aria-label={`Insert ${media.name} into content`}
                      onClick={insertMedia(media)}
                      size="large"
                    >
                      <PlusIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export { InsertMediaDialog };
